import { Badge } from '@interstate/components/Badge';
import { Box } from '@interstate/components/Box';
import type { ProposalMetadata } from '@makemydeal/dr-dash-types';

const ProposalChip: React.FC<{ record: ProposalMetadata }> = ({ record }) => {
    const isFourSquare = record.type === 'fourSquare';

    return (
        <Box display="flex" gap="8px" alignItems="center" justifyContent="flex-end">
            {record.isDefault && !isFourSquare && (
                <Badge variant="light">
                    <span>Default</span>
                </Badge>
            )}
            {record.isDefault && isFourSquare && (
                <Badge data-testid="badge-default-four-square" variant="light">
                    <span>Default 4-Square</span>
                </Badge>
            )}
            {!record.isDefault && isFourSquare && (
                <Badge data-testid="badge-four-square" variant="transparent">
                    <span>4-Square</span>
                </Badge>
            )}
            {record.isPrimary && (
                <Badge variant="info">
                    <span>Primary</span>
                </Badge>
            )}
        </Box>
    );
};

export default ProposalChip;
